<template>
  <div class="mac-banner-container" :style="{ marginTop: topDistance }">
    <div class="mac-banner">
      <p class="mac-title">{{ title }}</p>
      <p class="mac-desc">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MacBanner',
  props: {
    // 标题文字
    title: {
      type: String,
      default: ''
    },
    // 描述文字
    description: {
      type: String,
      default: ''
    },
    // 距离上方元素的高度，默认20px，支持带单位的字符串如"30px"、"2rem"等
    topDistance: {
      type: String,
      default: '20px'
    }
  },
  data() {
    return {
      // 组件数据
    }
  },
  methods: {
    // 组件方法
  },
  mounted() {
    // 使用组件根元素作为作用域，避免选择器冲突
    const container = this.$el
    const titleEl = container.querySelector('.mac-title')
    const descEl = container.querySelector('.mac-desc')
    // 为每个组件实例创建独立的时间线
    this.$ScrollTrigger = {
      trigger: container, // 使用组件根元素作为触发点
      start: 'top 80%',
      end: 'bottom 20%',
      toggleActions: 'play none none none',
      id: `trigger-${this._uid}`, // 使用Vue实例唯一ID作为标识
      once: true,
    }
    const tl = this.$gsap.timeline({
      defaults: {duration: 1, ease: 'power3.out'},
      scrollTrigger: this.$ScrollTrigger
    })

    // 初始状态设置（只针对当前组件内的元素）
    tl.set([titleEl, descEl], {opacity: 0, y: 100 })
        .to(titleEl, {opacity: 1, y: 0})
        .to(descEl, {opacity: 1, y: 0}, '-=0.7')
  },
  beforeDestroy() {
    // 组件销毁前清理
  }
}
</script>

<style scoped>
/* 基础容器样式 */
.mac-banner-container {
  width: 100%;
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  padding: 15px 0;
  box-sizing: border-box;
  overflow: hidden;
  padding-bottom: 110px;
}

/* 横幅内容容器 */
.mac-banner {
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 0;
}

/* 左侧标题样式 - 居中显示 */
.mac-title {
  opacity: 0;
  font-size: 3em;
  color: #1d1d1f;
  letter-spacing: -0.015em;
  line-height: 1.1;
  margin: 0 auto; /* 居中对齐 */
  position: absolute;
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平居中 */
  white-space: nowrap;
}

/* 右侧描述样式 */
.mac-desc {
  font-size: 1.5em;
  color: #1d1d1f;
  line-height: 1.5;
  margin: 0;
  position: absolute;
  right: 200px;
  white-space: nowrap;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .mac-banner-container {
    min-height: 120px;
    padding: 20px 15px;
    padding-bottom: 10px;
  }

  .mac-banner {
    flex-direction: column;
    position: static;
    align-items: center; /* 子元素居中对齐 */
  }

  .mac-title {
    opacity: 0;
    position: static;
    font-size: 1.5em;
    margin-bottom: 10px;
    text-align: center; /* 文本居中 */
    transform: none; /* 移除平移效果 */
  }

  .mac-desc {
    position: static;
    font-size: 1.2em;
    text-align: center; /* 文本居中 */
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .mac-title {
    opacity: 0;
    left: 50%; /* 水平居中 */
    transform: translateX(-50%); /* 水平居中 */
    font-size: 2.8em;
  }

  .mac-desc {
    right: 100px;
    font-size: 1.4em;
  }
}

/* 中等屏幕适配 */
@media (min-width: 1025px) and (max-width: 1440px) {
  .mac-title {
    opacity: 0;
    left: 50%; /* 水平居中 */
    transform: translateX(-50%); /* 水平居中 */
  }

  .mac-desc {
    right: 100px;
  }
}
</style>

